export { default } from "./table-menu-section";
